/**
 * Read access to the registered-source list (`GET /api/v3/sources`) — which
 * systems carry data, with their status, item count and last sync. All network
 * access goes through `apiFetch`; the response is validated at the boundary.
 */

import { type RegisteredSource, parseRegisteredSources } from "../types/dataSource";
import { apiFetch } from "../utils/apiClient";

class DataSourcesService {
	async listSources(): Promise<RegisteredSource[]> {
		const resp = await apiFetch("/api/v3/sources");
		if (!resp.ok) {
			throw new Error(`List data sources failed: ${resp.status}`);
		}
		return parseRegisteredSources(await resp.json());
	}
}

export const dataSourcesService = new DataSourcesService();
export default dataSourcesService;
